
import { BaseModel } from '../../../../../../core/_base/crud';
import { Time } from '@angular/common';

export class BOMPhuLieu extends BaseModel{
    public static DEFAULT__GIAIDOAN_BTP = 2;
    public static DEFAULT__KHOILUONGCANTINH = 100;

    IdBOMPhuLieu : number
    MaBOMPhuLieu : string
    MaBOMPhuLieuOld : string
    TenBOMPhuLieu : string
    NgayTao : string
    NguoiTao : number
    TenNguoiTao : string
    TrangThaiCode : string
    TrangThaiName : string
    IdQTSX : number
    MaQTSX : number
    IdThanhPham : number
    MaThanhPham : string
    TenThanhPham : string
    DongSanPham : number
    LanBanHanh : number
    NgayBanHanh : string
    ListNPL : BOMPhuLieuCt[]
    TreeBTP : TreeBTP
    HieuSuat : number
    NSTBCN : number
    LinkQTSX : any[]
    NoiDungSuaDoi: string
    BoM_ThuHoi : number
    BoM_ThuHoi_Number: string
    clear(){
        this.IdBOMPhuLieu  = 0
        this.MaBOMPhuLieu  = ""
        this.TenBOMPhuLieu  = ""
        this.NgayTao  = ""
        this.NguoiTao  = 0
        this.TenNguoiTao  = ""
        this.TrangThaiCode  = ""
        this.TrangThaiName  = ""
        this.IdQTSX  = 0
        this.MaQTSX  = 0
        this.IdThanhPham  = 0
        this.MaThanhPham  = ""
        this.TenThanhPham  = ""
        this.DongSanPham  = 0
        this.LanBanHanh  = 1
        this.NgayBanHanh  = ""
        this.ListNPL = []
        this.TreeBTP = new TreeBTP()
        this.MaBOMPhuLieuOld = ""
        this.HieuSuat = 100;
        this.NSTBCN = null;
        this.LinkQTSX = [];
        this.NoiDungSuaDoi = ''
        this.BoM_ThuHoi = 0
        this.BoM_ThuHoi_Number = ''
    }

    copy(item: BOMPhuLieu){
        this.IdBOMPhuLieu  = item.IdBOMPhuLieu
        this.MaBOMPhuLieu  = item.MaBOMPhuLieu
        this.TenBOMPhuLieu  = item.TenBOMPhuLieu
        this.NgayTao  = item.NgayTao
        this.NguoiTao  = item.NguoiTao
        this.TenNguoiTao  = item.TenNguoiTao
        this.TrangThaiCode  = item.TrangThaiCode
        this.TrangThaiName  = item.TrangThaiName
        this.IdQTSX  = item.IdQTSX
        this.MaQTSX  = item.MaQTSX
        this.IdThanhPham  = item.IdThanhPham
        this.MaThanhPham  = item.MaThanhPham
        this.TenThanhPham  = item.TenThanhPham
        this.DongSanPham  = item.DongSanPham
        this.LanBanHanh  = item.LanBanHanh
        this.NgayBanHanh  = item.NgayBanHanh
        this.ListNPL = item.ListNPL
        this.TreeBTP = item.TreeBTP
        this.MaBOMPhuLieuOld = item.MaBOMPhuLieuOld
        this.HieuSuat = item.HieuSuat;
        this.NSTBCN = item.NSTBCN;
        this.LinkQTSX = item.LinkQTSX;
        this.NoiDungSuaDoi = item.NoiDungSuaDoi
        this.BoM_ThuHoi = item.BoM_ThuHoi
        this.BoM_ThuHoi_Number = item.BoM_ThuHoi_Number
    }
}

export class BOMPhuLieuCt extends BaseModel{
    Id : number
    BOMPhuLieuId : number
    IdNL : number
    MaNL : string
    TenNL : string
    IsNLC : boolean
    HieuSuatNLTruocTron : number
    TyLeTronMe : number
    LaBTP : boolean // null là Không là BTP - false: là BTP không BOMPhuLieu - true: là BTP có BOMPhuLieu
    ThuocBTP : number
    AcceptDelete: boolean // LaBTP = false => AcceptDelete = true |  LaBTP = true => AcceptDelete = false
    ListHH: any[]
    ListGroupHH: any[]
    ListHieuSuat: number[]
    KhoiLuongCanSX100: number
    
    clear(){
        this.Id = 0
        this.BOMPhuLieuId = 0
        this.IdNL = 0
        this.MaNL = ""
        this.TenNL = ""
        this.IsNLC = false
        this.HieuSuatNLTruocTron = 0
        this.TyLeTronMe = 0
        this.LaBTP = null
        this.ThuocBTP = 0
        this.AcceptDelete = true
        this.ListHH = []
        this.ListGroupHH = []
        this.ListHieuSuat = []
        this.KhoiLuongCanSX100 = 0
        
    }
    
    copy(item: BOMPhuLieuCt){
        this.Id = item.Id
        this.BOMPhuLieuId = item.BOMPhuLieuId
        this.IdNL = item.IdNL
        this.MaNL = item.MaNL
        this.TenNL = item.TenNL
        this.IsNLC = item.IsNLC
        this.HieuSuatNLTruocTron = item.HieuSuatNLTruocTron
        this.TyLeTronMe = item.TyLeTronMe
        this.LaBTP = item.LaBTP
        this.ThuocBTP = item.ThuocBTP
        this.AcceptDelete = item.AcceptDelete
        this.ListHH = []
        this.ListGroupHH = item.ListGroupHH
        this.ListHieuSuat = item.ListHieuSuat
        this.KhoiLuongCanSX100 = item.KhoiLuongCanSX100
       
    }
}

export class TreeBTP extends BaseModel{
    IdNLC : number
    MaNLC : string
    TenNLC : string
    IdThanhPham : number
    MaThanhPham : string
    TenThanhPham : string
    ListLoopGiaiDoan : LoopGiaiDoan[]
    clear(){
        this.IdNLC = 0
        this.MaNLC = ""
        this.TenNLC = ""
        this.IdThanhPham = 0
        this.MaThanhPham = ""
        this.TenThanhPham = ""
        this.ListLoopGiaiDoan = []
    }
}

export class LoopGiaiDoan extends BaseModel{
    Id: number
    BOMPhuLieuId: number
    HieuSuat : number
    IdGiaiDoan : number
    TenGiaiDoan: string
    IdBTP : number
    MaBTP : string
    TenBTP : string
    clear(){
        this.HieuSuat = 0
        this.IdGiaiDoan = 0
        this.IdBTP = 0
        this.MaBTP = ""
        this.TenBTP = ""
        this.Id = 0
        this.BOMPhuLieuId = 0
        this.TenGiaiDoan = ""
    }
}

export class __DEFAULT__IDLOAIHH{
    public static NGUYENLIEU = 1;
    public static PHULIEU = 2;
    public static THANHPHAM = 4;
    public static BANTHANHPHAM = 5;
    public static BAOBI = 6;
}
    
export class __DEFAULT__DSP{
    public static AD_FD = 1;
    public static VIEN = 2;
    public static HON_HOP = 3;
    public static BAN_THANH_PHAM = 4;
    public static PHU_LIEU_CT = 5;

    public static AD_FD_NAME = "AD/FD";
    public static VIEN_NAME = "VIÊN";
    public static HON_HOP_NAME = "HỖN HỢP";
    public static CT_NAME = "DÒNG SẢN PHẨM CT";

    public static LIST_DSP = [
        {
            ID   : __DEFAULT__DSP.AD_FD,
            NAME : __DEFAULT__DSP.AD_FD_NAME
        },
        {
            ID   : __DEFAULT__DSP.VIEN,
            NAME : __DEFAULT__DSP.VIEN_NAME
        },
        {
            ID   : __DEFAULT__DSP.HON_HOP,
            NAME : __DEFAULT__DSP.HON_HOP_NAME
        },
        {
            ID   : 0,
            NAME : "KHÁC"
        }
    ];

    
}

export class ListStep3 extends BaseModel{
    IdKV : number
    MaKV : string
    TenKV : string
    DisplayColumnsExtends : DisplayColumnsExtend[]
    DisplayColumnsExtendsString : string[]
    DataColumns : any[];
    clear(){
        this.IdKV = 0
        this.MaKV = ""
        this.TenKV = ""
        this.DisplayColumnsExtends = []
        this.DisplayColumnsExtendsString = []
        this.DataColumns = []
    }
}

export class DisplayColumnsExtend{
    name: string
    displayName: string
    IdThietBi: number

    constructor(__name: string = "",
        __displayName: string = "",
        __idThietBi: number = 0) {
		this.name = __name;
        this.displayName = __displayName;
        this.IdThietBi = __idThietBi;
	}
}

export class ListBTPStep3 extends BaseModel{
   IdBTP : number
   MaBTP : string
   TenBTP : string
   ListDetails : ListDetail[]
}

export class ListDetail extends BaseModel{
    IdCongDoan : number
    IdPhanXuong : number
    ListThietBi : ListThietBi[]
    clear(){
        this.IdCongDoan = 0;
        this.IdPhanXuong = 0;
        this.ListThietBi = []
    }
}

export class ListThietBi extends BaseModel{
    IdThietBi: number
    TenThietBi: string
    clear(){
        this.IdThietBi = 0;
        this.TenThietBi = "";
    }
}

